import { Flower2 } from "lucide-react";

export function Shell({ children, progress, showProgress = true, onExit }) {
  return (
    <div className="min-h-screen bg-[hsl(var(--marfil))] text-[hsl(var(--texto))]">
      <header className="no-print sticky top-0 z-10 bg-[hsl(var(--marfil))]/95 backdrop-blur border-b border-[hsl(33_25%_86%)]">
        <div className="max-w-2xl mx-auto px-5 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Flower2 className="h-5 w-5 text-[hsl(var(--olivo))]" aria-hidden="true" />
            <span
              className="font-serif text-lg text-[hsl(var(--texto))]"
              data-testid="app-title"
            >
              Climaterio Claro
            </span>
          </div>
          {onExit && (
            <button
              onClick={onExit}
              className="text-sm text-[hsl(var(--olivo))] hover:underline font-medium"
              data-testid="exit-btn"
            >
              Salir
            </button>
          )}
        </div>
        {showProgress && typeof progress === "number" && (
          <div
            className="max-w-2xl mx-auto px-5 pb-3"
            aria-label="Progreso del cuestionario"
          >
            <div className="cc-progress-track" role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100}>
              <div
                className="cc-progress-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="text-xs text-[hsl(var(--muted-foreground))] mt-1 text-right">
              {progress}%
            </div>
          </div>
        )}
      </header>
      <main className="max-w-2xl mx-auto px-5 py-6 pb-32">{children}</main>
    </div>
  );
}

export function StepFooter({ children }) {
  return (
    <div className="no-print fixed bottom-0 inset-x-0 bg-[hsl(var(--marfil))]/95 backdrop-blur border-t border-[hsl(33_25%_86%)] z-10">
      <div className="max-w-2xl mx-auto px-5 py-4 flex flex-col sm:flex-row gap-3 sm:justify-between">
        {children}
      </div>
    </div>
  );
}
